import { httpClient } from '@pascal/pascal-core';
import { getBalanceUrl } from '../../core/constants/endpoints';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';

class PlayerService {
  getBalance() {
    return httpClient.get(getBalanceUrl());
  }

  updateRealBalance() {
    this.getBalance().then((balance) => {
      userInfoStore.setBalance(balance);
    });
  }
}

export const playerService = new PlayerService();
